import React, { useState } from "react";
import { toast } from "sonner";
import Layout from "../components/Layout";
import GlassCard from "../components/GlassCard";
import SectionHeader from "../components/SectionHeader";
import DepositButton from "../components/DepositButton";
import { api } from "../lib/kk";

export default function PuppyWaitlist() {
  const [form, setForm] = useState({ name: "", email: "", phone: "", preference: "" });
  const [done, setDone] = useState(false);
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await api.post("/waitlist/puppy", form);
      setDone(true);
      toast.success("You're on the puppy waitlist!");
    } catch {
      toast.error("Something went wrong. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <Layout>
      <section className="py-20 md:py-24 px-6">
        <div className="max-w-[600px] mx-auto">
          <SectionHeader label="Puppy Waitlist" title="Reserve your" highlight="Frenchie" />
          <GlassCard hover={false} className="p-8">
            {done ? (
              <div className="text-center py-6" data-testid="puppy-success">
                <p className="text-[#4CAF50] text-xl font-semibold mb-2">You're on the list! 🎉</p>
                <p className="text-[#E0E0E0] mb-6">Secure your spot with a refundable $500 deposit.</p>
                <DepositButton packageId="puppy_deposit" label="Pay $500 Puppy Deposit" name={form.name} email={form.email} className="w-full" />
              </div>
            ) : (
              <form onSubmit={submit} className="space-y-4" data-testid="puppy-form">
                <input className="kk-input" placeholder="Name" required value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} data-testid="puppy-name" />
                <input className="kk-input" type="email" placeholder="Email" required value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })} data-testid="puppy-email" />
                <input className="kk-input" placeholder="Phone" required value={form.phone} onChange={(e) => setForm({ ...form, phone: e.target.value })} data-testid="puppy-phone" />
                <input className="kk-input" placeholder="Color / Gender Preference" required value={form.preference} onChange={(e) => setForm({ ...form, preference: e.target.value })} data-testid="puppy-preference" />
                <button type="submit" disabled={loading} className="kk-btn kk-btn-primary w-full rounded-full py-4 disabled:opacity-60" data-testid="puppy-submit">
                  {loading ? "Submitting…" : "Join Puppy Waitlist"}
                </button>
              </form>
            )}
          </GlassCard>

          <div className="mt-6 text-center">
            <div className="flex items-center gap-3 my-6">
              <div className="h-px bg-white/10 flex-1" />
              <span className="text-[#777] text-xs uppercase tracking-widest">or pay your hold deposit</span>
              <div className="h-px bg-white/10 flex-1" />
            </div>
            <DepositButton packageId="puppy_deposit" label="Pay $500 Puppy Hold Deposit" name={form.name} email={form.email} className="w-full sm:w-auto" />
          </div>
        </div>
      </section>
    </Layout>
  );
}
